# Deal Summary View
# =================
SupportMarketRateImagePresenterPresentation = require('../../presenters/market_rate_image_presenter')
SupportCurrentOrderModel = require('../../models/current_order')
SupportUtilsHelper = require('../../helpers/utils')
Backbone = require 'backbone'
Backbone.$ = $
SupportDealSummaryTemplate = require('../../../deal_summary.html.mustache')

class SupportDealSummaryView extends Backbone.View
  className: 'deal-summary'

  initialize: () ->
    @I18nScope = 'modules.support'
    @template = SupportDealSummaryTemplate
    @order = Groupon.Support.currentOrder
    @orderPresenter = new SupportCurrentOrderModel
    @dealData = @toDealHash()

  events:
    'click .v1-image': 'goToDealPage'
    'click .view_fine_print': 'showFinePrint'

  render: ->
    @$el.append toHtml(@template, @dealData, @I18nScope)

  goToDealPage: ->
    if @order.deal?.dealUrl?
      window.open(@order.deal.dealUrl, "_blank")
    else if @dealData.dealId?
      window.open("/deals/#{@dealData.dealId}", "_blank")

  toDealHash: () ->
    @orderPresenter.toDealHash()

  showFinePrint: ->
    SupportUtilsHelper.renderFinePrint()

module.exports = SupportDealSummaryView
